import React from 'react'

import { Outcome } from '@app/graphql/types'
import { CheckResultsLayout } from '@app/modules/Messages/Components/UtilityBillAICheckResults/Components/CheckResultsLayout'
import { UtilityBillAnalysisChecks } from '@app/modules/Messages/Components/UtilityBillAICheckResults/types'

export type ServicePeriodCheckResultsProps = {
  check: UtilityBillAnalysisChecks['servicePeriod']
}

export const ServicePeriodCheckResults = ({ check }: ServicePeriodCheckResultsProps) => {
  if (check.outcome === Outcome.Pass) {
    return null
  }

  return (
    <CheckResultsLayout>
      <CheckResultsLayout.Title>Nutzungszeitraum</CheckResultsLayout.Title>
      <CheckResultsLayout.Description>
        Der Nutzungszeitraum stimmt nicht mit der angegebenen Nutzungsdauer überein.
      </CheckResultsLayout.Description>
    </CheckResultsLayout>
  )
}
